export const getJerezData = () => ({
  name: "Jerez",
  country: "Espagne",
  description: "Jerez est une région viticole d'Andalousie, dans le sud de l'Espagne, produisant principalement des vins fortifiés (Sherry) de renommée mondiale. Cette région bénéficie d'un climat méditerranéen chaud et de sols calcaires qui donnent aux vins leur caractère unique.",
  type: "region",
  mapAreas: [
    { region: "Jerez", x: 30, y: 70, color: "#4B164C", size: 4 }
  ],
  statistics: {
    totalArea: "7,000 ha",
    production: "0.6 million hectolitres",
    appellations: "1 DO",
    villages: "3 communes",
    exportPercentage: "80%"
  },
  characteristics: {
    climate: "Climat méditerranéen chaud et sec avec influence atlantique",
    soil: "Sols calcaires (albariza), excellents pour la rétention d'eau",
    viticulture: "Viticulture traditionnelle, vendanges manuelles, système de solera"
  },
  wineStyles: {
    fino: "Sherry sec et léger, élevé sous voile de flor",
    manzanilla: "Sherry sec et délicat, produit à Sanlúcar de Barrameda",
    amontillado: "Sherry sec et complexe, avec des notes de noix",
    oloroso: "Sherry sec et puissant, sans voile de flor",
    palo_cortado: "Sherry rare et complexe, entre amontillado et oloroso",
    pedro_ximenez: "Sherry doux et concentré, à base de raisins séchés"
  },
  history: "La viticulture dans la région de Jerez remonte à l'époque phénicienne. Au Moyen Âge, les Arabes ont introduit la distillation. Le XVIe siècle a vu l'émergence du commerce avec l'Angleterre. Aujourd'hui, Jerez est reconnu comme la capitale mondiale du Sherry.",
  foodPairing: "Tapas, fruits de mer, fromages affinés, desserts, cuisine andalouse",
  subregions: {
    "jerez-de-la-frontera": {
      name: "Jerez de la Frontera",
      description: "Ville principale de la région produisant des Sherries de qualité, avec une forte identité andalouse.",
      characteristics: {
        climate: "Climat méditerranéen chaud et sec",
        soil: "Sols calcaires (albariza)",
        viticulture: "Viticulture traditionnelle, système de solera"
      },
      grapeVarieties: {
        white: ["Palomino", "Pedro Ximénez", "Moscatel"]
      },
      wineStyles: {
        "fino-jerez": "Sherry sec et léger",
        "amontillado-jerez": "Sherry sec et complexe",
        "oloroso-jerez": "Sherry sec et puissant"
      },
      foodPairing: "Tapas, fruits de mer, fromages, cuisine andalouse"
    },
    "sanlucar-de-barrameda": {
      name: "Sanlúcar de Barrameda",
      description: "Ville côtière produisant la Manzanilla, un Sherry unique avec une forte identité maritime.",
      characteristics: {
        climate: "Climat méditerranéen avec influence maritime",
        soil: "Sols calcaires et sableux",
        viticulture: "Viticulture traditionnelle, voile de flor"
      },
      grapeVarieties: {
        white: ["Palomino", "Pedro Ximénez", "Moscatel"]
      },
      wineStyles: {
        "manzanilla-sanlucar": "Sherry sec et délicat",
        "manzanilla-pasada": "Manzanilla vieillie et complexe"
      },
      foodPairing: "Fruits de mer, poissons, tapas, cuisine maritime"
    },
    "el-puerto-de-santa-maria": {
      name: "El Puerto de Santa María",
      description: "Ville côtière produisant des Sherries équilibrés, avec une forte identité portuaire.",
      characteristics: {
        climate: "Climat méditerranéen avec influence maritime",
        soil: "Sols calcaires et argileux",
        viticulture: "Viticulture traditionnelle, système de solera"
      },
      grapeVarieties: {
        white: ["Palomino", "Pedro Ximénez", "Moscatel"]
      },
      wineStyles: {
        "fino-puerto": "Sherry sec et équilibré",
        "amontillado-puerto": "Sherry sec et structuré"
      },
      foodPairing: "Poissons, fruits de mer, tapas, cuisine portuaire"
    },
    "montilla-moriles": {
      name: "Montilla-Moriles",
      description: "Région voisine produisant des vins similaires au Sherry, avec une forte identité montillaise.",
      characteristics: {
        climate: "Climat méditerranéen chaud",
        soil: "Sols calcaires et argileux",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Pedro Ximénez", "Moscatel", "Airen"]
      },
      wineStyles: {
        "montilla-fino": "Vin sec et léger",
        "pedro-ximenez-montilla": "Vin doux et concentré"
      },
      foodPairing: "Desserts, fromages bleus, cuisine andalouse"
    }
  }
}); 